const data = {
    "settings": {
        "template_id": 2,
        "primaryColor": "#C50000",
        "buttonColor": "#FF3434",
        "buttonBg": "#FFDCDC",
        "darkColor": "#000000",
        "seconderyColor": "#ffffff",
        "boxShadow": "0px 30px 80px 5px rgba(209, 43, 40, 0.3)",
        "bggradient": "linear-gradient(180deg, rgba(209, 43, 40, 0.09) 0%, rgba(255, 255, 255, 0.11) 100%)",
        "contactAddress": "linear-gradient(98.63deg, #FFF8F8 0%, rgba(255, 255, 255, 0) 100%)",
    },
    "location": {
        "id": 167,
        "name": "Tokyo Grill",
        "category": "Restaurant",
        "url": "http://127.0.0.1:5500/index.html",
        "logo": "./img/v1/logo.png",
        "logo_footer": "./img/v1/logo.png",
        "banner": {
            "title": "Tokyo Grill",
            "description": "Enjoy hibachi, teriyaki, sushi rolls, and classic Asian dishes — freshly prepared, flavorful, and satisfying every time.",
            "image": "./img/v1/hero_bg.webp",
            "thumbnail": "./img/v1/hero.jpg",
            "button_name": "Order Now",
            "button_link": "https://order.kloudeats.com/l/Tokyo-Grill/194"
        },
        "gallery": [
            {
                "original": "./img/v1/gallery/1.jpg",
                "thumbnail": "/img/v1/gallery/1.jpg"
            },
            {
                "original": "./img/v1/gallery/2.jpg",
                "thumbnail": "/img/v1/gallery/2.jpg"
            },
            {
                "original": "./img/v1/gallery/3.jpg",
                "thumbnail": "/img/v1/gallery/3.jpg"
            },
            {
                "original": "./img/v1/gallery/4.jpg",
                "thumbnail": "/img/v1/gallery/4.jpg"
            },
            {
                "original": "./img/v1/gallery/5.jpg",
                "thumbnail": "/img/v1/gallery/5.jpg"
            },
            {
                "original": "./img/v1/gallery/6.jpg",
                "thumbnail": "/img/v1/gallery/6.jpg"
            },
            {
                "original": "./img/v1/gallery/8.jpg",
                "thumbnail": "/img/v1/gallery/8.jpg"
            },
            {
                "original": "./img/v1/gallery/9.jpg",
                "thumbnail": "/img/v1/gallery/9.jpg"
            },
            {
                "original": "./img/v1/gallery/10.jpg",
                "thumbnail": "/img/v1/gallery/10.jpg"
            },
            {
                "original": "./img/v1/gallery/11.jpg",
                "thumbnail": "/img/v1/gallery/11.jpg"
            },
        ],
        "about": [
            {
                "img": "./img/v1/about1.jpg",
                "title": "Welcome to Tokyo Grill",
                "description": "At Tokyo Grill, it’s about simple, satisfying food and a welcoming place to enjoy it. Whether you’re stopping in for a quick lunch, picking up dinner for the family, or meeting friends for an easy meal, we focus on fresh flavors, generous portions, and consistent quality. It’s food you can rely on — cooked to order and served with care."
            },
            {
                "img": "./img/v1/about2.jpg",
                "title": "",
                "description": "Tokyo Grill is a casual Japanese and Asian grill serving freshly prepared hibachi, teriyaki, sushi, and customer favorites. Our menu is designed to be approachable and flavorful, making it easy to find something everyone will enjoy. With fast, friendly service and a relaxed atmosphere, Tokyo Grill is a go-to spot for dine-in or takeout."
            }
        ],
        "reviews": {
            "image": "./img/v1/review.jpg",
            "contents": [
                {
                    "review": "Tokyo GriLL has some of the Best Rice 🍚 I have tasted. I have been to a lot of Chinese Rice spots in my city 🌆 and this one☝🏽takes the points. Rice 🍚 so good and hot with steam everytime. Chinese Rice 🍚 off the ChizzLe(good)! Even the veggie 🥦 fried rice is good. Food very affordable. I promise that you won’t regret eating 🥣 here for Lunch or Dinner 🍽️ !!!",
                    "reviewer": "",
                },
                {
                    "review": "SHAZAM! This place is a hidden jewel along this stretch of Winchester. It’s much larger than you might think and has a bar as well. I grabbed lunch here with a friend this week because he suggested it, and he was SPOT ON. I had the hibachi salmon with friend rice and vegetables and he had the chicken fried rice. The salmon was cooked well and had a ton of flavor. The vegetables were soft but not mushy also with great flavor. Service was fast and friendly. I look forward to returning one day.",
                    "reviewer": "",
                },
                {
                    "review": "Food was excellent and very reasonably priced. The Memphis sushi roll was especially good. In addition, the ambience was nice and not crowded at all. The service was also very good. Definitely will return.",
                    "reviewer": "",
                },
                {
                    "review": "I just started eating sushi... My favorite are the deep fried dynomite rolls because they don't have cream cheese… I love them...",
                    "reviewer": "",
                },
                {
                    "review": "Tokyo Grill was nice and quiet on a weekday night, everything we ordered was pretty good, about exactly what you would expect! Generous portions for the price too.",
                    "reviewer": "",
                }
            ]
        },
        "social_media": [
            {
                icon: "facebook",
                link: "https://www.facebook.com/tokyogrillwinchester"
            },
            {
                icon: "instagram",
                link: "https://www.instagram.com/tokyogrill/"
            },
        ],
        "contact_us": {
            "phone": ["9013751699", "901-305-6368"],
            "address": "5848 Winchester Rd, Memphis, TN 38115",
            "background": "./img/v1/contactus-banner.webp",
            "business_hours": "Mon-Sun: 11:00 AM - 9:30 PM"
        },
    }
}
export default data
